import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { getAuthService } from '../shared/services/firebaseConfig';
import { useAuthStore } from '../features/auth/authStore';

export function useAuth() {
  const [user, setUser] = useState<User | null | undefined>(undefined);
  const auth = useAuthStore((state) => state.auth); // `undefined` = loading

  useEffect(() => {
    getAuthService().then((auth) => {
      const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
        setUser(firebaseUser ?? null);
      });
      return unsubscribe;
    });
  }, []);

  return { user, loading: user === undefined, auth };
}
